import AXIOS from "../services/axios";

export const getUsersList = async (limit, page, project, user, access) => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/users/?${
        project.id ? `&project__id=${project.id}` : ``
      }${user ? `&name=${user}` : ``}${
        access?.length ? `&access=${access.toString()}` : ``
      }${`&page_size=${limit}&page=${page}`}`
      `${process.env.REACT_APP_API_PATH}/users/?${
        project.id ? `&project__id=${project.id}` : ``
      }${user ? `&name=${user}` : ``}${
        access?.length ? `&access=${access.toString()}` : ``
      }${`&page_size=${limit}&page=${page}`}`
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const getTasksList = async (
  search,
  limit,
  page,
  project,
  property,
  user,
  start_date,
  end_date,
  access
) => {
  const response = { data: null, error: null };

  try {
    const { data } = await AXIOS.get(`${
      process.env.REACT_APP_API_PATH
    }/tasksearch?created_at_after=${start_date}&created_at_before=${end_date}&page_size=${limit}&page=${page}
      ${project?.length ? `&project_id=${project.toString()}` : ``}${
      property?.length ? `&property_id=${property.toString()}` : ``
    }
      ${user?.length ? `&assigned_to=${user.toString()}` : ``}${
      search ? `&task_name=${search}` : ``
    } ${access?.length ? `&access=${access.toString()}` : ``}`);
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const getProjectUsersList = async (
  currUser,
  proj,
  prop,
  user,
  page,
  access
) => {
  const response = { data: null, error: null };
  const propIds = Array.isArray(prop)
      ? prop.map((p) => (typeof p === "object" ? p?.id : p)).filter(Boolean)
      : prop;
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/users/project/user?info=${currUser}${
        propIds?.length
          ? `&group=1&property=${propIds.toString()}`
          : proj?.length
          ? `&group=0&project=${proj.toString()}`
          : ``
      }${user ? `&name=${user}` : ``}${
        !propIds?.length && !proj?.length ? `&group=2` : ""
      }&page=${page}&page_size=20${
        access?.length ? `&access=${access.toString()}` : ``
      }`
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const getUserDetail = async (id) => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/users/${id}`
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const getAccessList = async () => {
  const response = { result: null, err: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/dropdown/access`
    );
    response.result = data;
  } catch (err) {
    response.err = err.response;
  }
  return response;
};

export const addUsers = async (
  id,
  user_name,
  email_id,
  phone,
  role,
  project,
  property,
  access,
  action
) => {
  const response = {
    status: null,
    message: null,
  };
  const obj = {
    name: user_name,
    email: email_id,
    phone_number: phone,
    role_ids: role,
    project_ids: project,
    property_ids: property,
    access_ids: access,
  };

  try {
    if (action === "edit") {
      const { data } = await AXIOS.patch(
        `${process.env.REACT_APP_API_PATH}/users/${id}/`,
        obj
      );

      response.status = data;
      response.message = data;
    } else {
      const { data } = await AXIOS.post(
        `${process.env.REACT_APP_API_PATH}/users/`,
        obj
      );
      response.status = data;
      response.message = data;
    }
  } catch (err) {
    response.error = err.response.data.message;
  }
  return response;
};

export const getColorPreferences = async (id) => {
  const response = { result: null, err: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/users/color_preferences`
    );
    // console.log({ data });
    response.result = data;
  } catch (err) {
    response.err = err.response;
  }
  return response;
};

export const getAllUsersProject = async (id) => {
  const response = { result: null, err: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/users/project/${id}/all`,
    );
    response.result = data;
  } catch (err) {
    response.err = err.response;
  }
  return response;
};
